import React from "react";

export interface TickerItem {
  id: string;
  text: string;
  onClick?: () => void;
}

interface TickerBannerProps {
  items: TickerItem[];
}

export const TickerBanner: React.FC<TickerBannerProps> = ({ items }) => {
  if (!items.length) return null;

  return (
    <div className="vault-ticker">
      <div className="vault-ticker-content">
        {items.map((item) => (
          <span
            key={item.id}
            className={`vault-ticker-item${item.onClick ? " vault-ticker-item--clickable" : ""}`}
            onClick={item.onClick}
          >
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
};
